import React, { Component } from 'react';
import DashboardLayout from '../../layouts/DashboardLayout';

export default class AdminHome extends Component {
  render() {
    return (
      <DashboardLayout>
        <h1>This is Admin Dashboard is Coming Soon..!</h1>
      </DashboardLayout>
    );
  }
}
